import { render, staticRenderFns } from "./dataSet.vue?vue&type=template&id=f2950ac4&scoped=true"
import script from "./dataSet.vue?vue&type=script&lang=js"
export * from "./dataSet.vue?vue&type=script&lang=js"
import style0 from "./dataSet.vue?vue&type=style&index=0&id=f2950ac4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2950ac4",
  null
  
)

export default component.exports